<template><div><h1 id="spendeneingange-im-kollektiven-bereich" tabindex="-1"><a class="header-anchor" href="#spendeneingange-im-kollektiven-bereich"><span>Spendeneingänge im kollektiven Bereich</span></a></h1>
<p>Spendeneingänge im kollektiven Bereich — Listet Response-Ereignisse und Aktionen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Auswertung erstellt eine Datei aus Responseereignissen im gewählten Zeitraum [Datum von ... bis] für Adressen mit den gewählten Personenmerkmalen. Es wird auch die letzte Aktion zur Adresse aufgelistet, welche der zuständige Mitarbeiter eingegeben hat.</p>
<p>Pfad: <code v-pre>Personen → Auswertungen → Spendeneingänge im kollektiven Bereich</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>Personenmerkmale</dt>
<dd>mit Kommas trennen, mit ! ausschliessen, * alles</dd>
<dt>Datum von</dt>
<dd>leer = unbegrenzt, inklusive</dd>
<dt>Datum bis</dt>
<dd>leer = unbegrenzt, inklusive</dd>
<dt>Zuständige ID</dt>
<dd>zuständiger Mitarbeiter, * = alle</dd>
<dt>export in Excel/Textdatei</dt>
<dd>E = Tabellenformat (tab-delimited); T = Text</dd>
<dt>Ausgabe</dt>
<dd>Standard (Drucker: A4-Landscape)</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Adrnum</td>
<td>Personen-ID</td>
</tr>
<tr>
<td>Ereig.</td>
<td>Ereignisnummer</td>
</tr>
<tr>
<td>EP</td>
<td>Ereignispositionsnummer</td>
</tr>
<tr>
<td>Datum</td>
<td>Zahlungsdatum</td>
</tr>
<tr>
<td>Betrag</td>
<td>Zahlungsbetrag</td>
</tr>
<tr>
<td>letz. Akt.</td>
<td>Datum der letzten Aktion zur Adresse (mit gewähltem Mitarbeiter, falls Mitarbeiter gewählt wurde, sonst: letzte erfasste Aktion)</td>
</tr>
<tr>
<td>Code</td>
<td>Aktionscode der letzten ausgewiesenen Aktion</td>
</tr>
<tr>
<td>ID</td>
<td>Mitarbeiter-Code, welcher letzte ausgewiesene Aktion erfasst hat</td>
</tr>
<tr>
<td>Name</td>
<td>Adressname</td>
</tr>
</tbody>
</table>
<div class="language-text line-numbers-mode" data-highlighter="prismjs" data-ext="text"><pre v-pre><code><span class="line">Datenausgabe                                03.10.1998 15:56:49 pav  Seite     0</span>
<span class="line"></span>
<span class="line">Spendeneingänge im kollektiven Bereich</span>
<span class="line">Personenmerkmale: \*</span>
<span class="line">Datum von.....: 01.01.1998 bis: 01.09.1998</span>
<span class="line">Zuständige ID.: \*</span>
<span class="line">export in Excel/Textdatei: T</span>
<span class="line"></span>
<span class="line"></span>
<span class="line">Adrnum Ereig. EP Datum            Betrag letz. Akt. Code ID  Name</span>
<span class="line">-------- ------ -- -------- -------------- ---------- ---- --- -----------------</span>
<span class="line">403   9995 00 27.04.98         150.00 10.03.97   spez     Maeder AG Landesp</span>
<span class="line">.      . 00 27.04.98         200.00</span>
<span class="line">415   9995 00 27.04.98         210.00                     Maurer-Maerki Hel</span>
<span class="line">521   4005 96 05.02.98         100.00                     Centre Social Pro</span>
<span class="line">.      . 96 05.02.98         100.00</span>
<span class="line">.      . 96 05.02.98         100.00</span>
<span class="line">1670   9998 00 29.06.98          10.00                     Buetiger Jean J.</span>
<span class="line">.</span>
<span class="line"></span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div></div></div><p>Zeigt für alle Adressen und beliebige Mitarbeiter die Spendeneingänge in den ersten 3 Quartalen des Jahres 1998.</p>
</div></template>


